import { useEffect, useRef } from 'react';
import { useNavigate } from 'react-router-dom';
import {ADMIN_LOGOUT} from "../Store/Contans/AdminContans";
import {useDispatch} from "react-redux";

const InactivityHandler = () => {
  const lastActiveTimeRef = useRef(Date.now());
//   const navigate = useNavigate();

  const INACTIVITY_LIMIT = 60 * 60 * 1000; 
  const dispatch = useDispatch();
  const logout = () => {
       dispatch({type: ADMIN_LOGOUT});
       window.location.reload();
       window.location.href = "/";
  };

  useEffect(() => {
    const storedTime = localStorage.getItem('lastActiveTime');
    if (storedTime) {
      const timeElapsed = Date.now() - Number(storedTime);
      if (timeElapsed >= INACTIVITY_LIMIT) {
        logout();
      }
    }

    const resetInactivityTimer = () => {
      const now = Date.now();
      lastActiveTimeRef.current = now;
      localStorage.setItem('lastActiveTime', now.toString());
    };

    const checkInactivity = () => {
      const currentTime = Date.now();
      const timeElapsed = currentTime - lastActiveTimeRef.current;
      if (timeElapsed >= INACTIVITY_LIMIT) {
        logout();
      }
    };

    const interval = setInterval(checkInactivity, 10000);

    document.addEventListener('mousemove', resetInactivityTimer);
    document.addEventListener('keydown', resetInactivityTimer);
    document.addEventListener('mousedown', resetInactivityTimer);
    document.addEventListener('visibilitychange', () => {
      if (document.visibilityState === 'visible') {
        resetInactivityTimer();
      }
    });
    window.addEventListener('focus', resetInactivityTimer);

    resetInactivityTimer();

    return () => {
      clearInterval(interval);
      document.removeEventListener('mousemove', resetInactivityTimer);
      document.removeEventListener('keydown', resetInactivityTimer);
      document.removeEventListener('mousedown', resetInactivityTimer);
      document.removeEventListener('visibilitychange', resetInactivityTimer);
      window.removeEventListener('focus', resetInactivityTimer);
    };
  }, []);

  return null;
};

export default InactivityHandler;